import * as React from "react";
const SvgPersonMale = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-6 8v-3a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v3z" }));
export default SvgPersonMale;
